import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Sparkles, Zap, TrendingUp, Package } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Compact badge showing the user's currently equipped Booster Pack.
 * If no pack equipped, shows a subtle CTA to /booster-packs.
 */
export function ActiveBoostBadge({ address, compact = false }) {
    const [boost, setBoost] = useState(null);

    useEffect(() => {
        if (!address) return;
        fetch(`${API_URL}/api/booster-packs/active-boost/${address}`)
            .then(r => r.json())
            .then(setBoost)
            .catch(() => setBoost(null));
    }, [address]);

    if (!address) return null;

    // No pack equipped — small CTA
    if (!boost?.pack) {
        if (compact) return null;
        return (
            <Link
                to="/booster-packs"
                className="inline-flex items-center gap-2 px-3 py-1.5 rounded-lg bg-white/5 border border-white/10 hover:border-[#FFD700]/40 transition text-xs text-white/50 hover:text-[#FFD700]"
                data-testid="active-boost-cta"
            >
                <Package className="w-3.5 h-3.5" />
                <span>Boost ton compte avec un Booster Pack</span>
            </Link>
        );
    }

    const p = boost.pack;
    return (
        <Link
            to="/booster-packs"
            className="inline-flex items-center gap-2.5 px-3 py-1.5 rounded-lg border transition group"
            style={{
                backgroundColor: `${p.color}15`,
                borderColor: `${p.color}40`,
            }}
            data-testid="active-boost-badge"
        >
            <Sparkles className="w-4 h-4" style={{ color: p.color }} />
            <div className="flex items-center gap-2 text-xs">
                <span className="font-bold text-white">{p.label}</span>
                <span className="text-white/50">·</span>
                <span className="flex items-center gap-1 text-white/70">
                    <Zap className="w-3 h-3 text-[#FFD700]" />
                    +{boost.reward_boost_pct}%
                </span>
                {boost.jackpot_ticket_mult > 1 && (
                    <>
                        <span className="text-white/50">·</span>
                        <span className="flex items-center gap-1 text-white/70">
                            <TrendingUp className="w-3 h-3 text-[#9B6FE8]" />
                            ×{boost.jackpot_ticket_mult}
                        </span>
                    </>
                )}
                {boost.fee_discount_pct > 0 && (
                    <>
                        <span className="text-white/50">·</span>
                        <span className="text-[#00FF66] font-mono">-{boost.fee_discount_pct}% fee</span>
                    </>
                )}
            </div>
        </Link>
    );
}
